// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const authClient = createTypedClient();
export const createAuthClient = (config) => createTypedClient(config);
